import {gql} from '@apollo/client';
import {compact} from '@benchling/js-utils';
import React from 'react';

import FragmentWrapper from 'graphql-client/FragmentWrapper';
import {WithoutTypenames} from 'graphql-client/WithoutTypenames';
import {PolicyFilterPolicy as GeneratedPolicyFilterPolicy} from 'search/filters/__generated/PolicyFilterPolicy';
import DropdownFilterForm, {prefixedToggleText} from 'search/filters/base/DropdownFilterForm';
import {Filter, MultiValueFilter} from 'search/SearchConstants';
import {OptionData} from 'ui-library/menus/MenuConstants';
import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

export const POLICY_FILTER_POLICY = gql`
  fragment PolicyFilterPolicy on PolicyNode {
    id
    name
  }
`;

export const PolicyFilterFragment: FragmentWrapper<PolicyFilterPolicy> = {
  fragmentName: 'PolicyFilterFragment',
  fragment: POLICY_FILTER_POLICY,
};

export type PolicyFilterPolicy = WithoutTypenames<GeneratedPolicyFilterPolicy>;

interface PolicyFilterFormProps extends BaseFilterFormProps {
  filter: MultiValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: Filter) => void;
  onRemove?: () => void;
  policies: Array<PolicyFilterPolicy>;
}

export interface PolicyFilterFormExtraProps {
  policies: Array<PolicyFilterPolicy>;
}

export const NO_TENANT_ROLE_FILTER = {
  name: 'None',
  // Keep in sync with benchling/parties/users/user_search.py
  value: 'NO_TENANT_ROLE',
};

export default function PolicyFilterForm(
  props: PolicyFilterFormProps & PolicyFilterFormExtraProps
): JSX.Element {
  const baseProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);

  const policies = props.policies.map((policy) => ({
    name: policy.name,
    value: policy.id,
  }));
  const optionDatas = compact<OptionData>([NO_TENANT_ROLE_FILTER, ...policies]);

  return (
    <DropdownFilterForm
      {...baseProps}
      dropdownToggleText={prefixedToggleText('Role', optionDatas, props.filter)}
      filterStyle={props.filterStyle}
      isMulti={true}
      isSearchable={false}
      onChangeValue={(value: Array<string>) => {
        props.onChangeFilter({...props.filter, value});
      }}
      onRemove={props.onRemove}
      optionDatas={optionDatas}
      value={props.filter.value}
    />
  );
}
